import di from 'dependeny-injection';

import './model/inquiry';
import edireco_binding from '@lib/edireco-binding.riot';
import loading from '@lib/loading.riot'

di.riot.register('edireco-binding', edireco_binding);
di.riot.register('loading', loading);

import root from './tags/index.riot';

di.riot.mount('binding');
di.riot.mount('number-format-tag');
di.riot.mount('pagination-tag');
di.riot.mount('raw-tag');
di.riot.mount('edireco-binding');
di.riot.mount('loading');

const mounts = {
    'root-tag':  di.riot.component(root)
};

mounts['root-tag'](
    document.getElementById('js-target')
);
